module.exports = __webpack_public_path__ + "img/1047.15062472.svg";